/**
 * @fileoverview Create Group sub-modal component
 */

import { useState } from 'react'
import { Modal, Stack, TextInput, Group, Button } from '@mantine/core'
import { IconDeviceFloppy } from '@tabler/icons-react'
import { useArcTranslation } from 'hooks'
import type { CreateGroupModalProps } from './interfaces'

export const CreateGroupModal = ({
  opened,
  onClose,
  onSubmit,
  loading,
}: CreateGroupModalProps) => {
  const { t } = useArcTranslation()
  const [groupName, setGroupName] = useState('')
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async () => {
    if (!groupName.trim()) {
      setError(t('add_students_modal.field_required'))
      return
    }

    try {
      await onSubmit(groupName.trim())
      setGroupName('')
      setError(null)
      onClose()
    } catch {
      // Error handling is done in the hook
    }
  }

  const handleClose = () => {
    setGroupName('')
    setError(null)
    onClose()
  }

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title={t('add_students_modal.create_group_title')}
      centered
      size='sm'
      zIndex={201}
    >
      <Stack spacing='md'>
        <TextInput
          label={t('add_students_modal.group_name')}
          placeholder={t('add_students_modal.group_name_placeholder')}
          value={groupName}
          onChange={e => {
            setGroupName(e.target.value)
            setError(null)
          }}
          error={error}
          size='md'
          data-autofocus
        />

        <Group position='right' spacing='md'>
          <Button variant='default' onClick={handleClose} size='md'>
            {t('add_students_modal.cancel')}
          </Button>
          <Button
            variant='filled'
            color='teal'
            onClick={handleSubmit}
            loading={loading}
            leftIcon={<IconDeviceFloppy size={18} />}
            size='md'
          >
            {t('add_students_modal.save')}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
